import { Component, OnInit } from '@angular/core';
import { ArchiveService } from '../../services/archive.service';
import { GlobalSearchService } from '../../services/globalsearchservice.service';

@Component({
	selector: 'app-archived-statements',
	templateUrl: './archived-statements.component.html',
	styleUrls: ['./archived-statements.component.scss']
})
export class ArchivedStatementsComponent implements OnInit {

	color = 'blue';
	archives: any[] = [];
	loading = false;
	downloadingId: any = false;

	schedule: any = { enabled: true, day: 25, printonly: true, type: ['debit'] };
	savingSchedule = false;
	running = false;

	constructor(private archiveService: ArchiveService, private globalSearchService: GlobalSearchService) {
		this.color = this.globalSearchService.getColor();
	}

	ngOnInit(): void {
		this.load();
		this.loadSchedule();
	}

	loadSchedule(): void {
		this.archiveService.getStatementArchiveSchedule().subscribe((r: any) => {
			if (r && typeof r === 'object') {
				this.schedule = {
					enabled: !!r.enabled,
					day: r.day || 25,
					printonly: r.printonly !== false,
					type: Array.isArray(r.type) && r.type.length ? r.type : ['debit'],
				};
			}
		});
	}

	get includeCredits(): boolean {
		return (this.schedule.type || []).indexOf('credit') > -1;
	}

	set includeCredits(v: boolean) {
		this.schedule.type = v ? ['debit', 'credit'] : ['debit'];
	}

	saveSchedule(): void {
		this.savingSchedule = true;
		this.archiveService.saveStatementArchiveSchedule(this.schedule).subscribe((r: any) => {
			this.savingSchedule = false;
			if (r && r.success) {
				this.globalSearchService.showNotification('Schedule saved', 'success', 'bottom', 'left');
			} else {
				this.globalSearchService.showNotification('Save failed', 'danger', 'bottom', 'left');
			}
		}, () => {
			this.savingSchedule = false;
			this.globalSearchService.showNotification('Save failed', 'danger', 'bottom', 'left');
		});
	}

	runNow(): void {
		this.running = true;
		this.globalSearchService.showNotification('Generating statements — this can take a few minutes…', 'info', 'bottom', 'left');
		this.archiveService.runStatementArchive({}).subscribe((r: any) => {
			this.running = false;
			if (r && r.success) {
				this.globalSearchService.showNotification('Generated ' + r.count + ' statements', 'success', 'bottom', 'left');
				this.load();
			} else {
				this.globalSearchService.showNotification('Run failed', 'danger', 'bottom', 'left');
			}
		}, () => {
			this.running = false;
			this.globalSearchService.showNotification('Run failed', 'danger', 'bottom', 'left');
		});
	}

	load(): void {
		this.loading = true;
		this.archiveService.getStatementArchives().subscribe((r: any) => {
			this.archives = (r && Array.isArray(r.archives)) ? r.archives : [];
			this.loading = false;
		}, () => {
			this.loading = false;
		});
	}

	download(row: any): void {
		this.downloadingId = row.id;
		this.archiveService.downloadStatementArchive({ id: row.id }).subscribe((r: any) => {
			this.downloadingId = false;
			if (r && r.success && r.pdf) {
				this.globalSearchService.downloadPdf(r.pdf, r.filename || ('Statements-' + row.id + '.pdf'));
			} else {
				this.globalSearchService.showNotification(r && r.message ? r.message : 'Archive file not available', 'danger', 'bottom', 'left');
			}
		}, () => {
			this.downloadingId = false;
			this.globalSearchService.showNotification('Download failed', 'danger', 'bottom', 'left');
		});
	}

	fileSize(bytes: any): string {
		const b = parseFloat(bytes);
		if (!b || isNaN(b)) {
			return '';
		}
		if (b < 1024) {
			return b + ' B';
		}
		if (b < 1024 * 1024) {
			return (b / 1024).toFixed(1) + ' KB';
		}
		return (b / (1024 * 1024)).toFixed(1) + ' MB';
	}

}
